import { Component, OnInit, Inject } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { ContratistaModel } from 'src/app/models/contratista/ContratistaModel';
import { SedeModel } from 'src/app/models/sede/SedeModel';
import { SedeService } from 'src/app/services/sede/sede.service';
import { ContratistaService } from 'src/app/services/contratista/contratista.service';
import { RolService } from 'src/app/services/roles/rol.service';
import { IRoleModel } from 'src/app/models/interfaces/IRoleModel';
import { IUsuarioRegistrarModel } from 'src/app/models/interfaces/seguridad/IUsuarioRegistrarModel';
import { UsuarioRegistrarModel } from 'src/app/models/seguridad/UsuarioRegistrarModel';
import { SeguridadUsuarioService } from 'src/app/services/seguridad/seguridad-usuario.service';
import { UsuarioService } from 'src/app/services/seguridad/usuario/usuario.service';
import { ISeguridadUsuarioResultadoBusquedaModel } from 'src/app/models/interfaces/seguridad/ISeguridadUsuarioResultadoBusquedaModel';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { filter, map, startWith, switchMap } from 'rxjs/operators';
import { eTypeResult, ParametrosMaestro, Roles, TipoUsuario } from 'src/app/models/common/enumModel';
import { IContratistaModel } from 'src/app/models/interfaces/contratista/IContratistaModel';
import { FilterContratistaModel } from 'src/app/models/contratista/FilterContratistaModel';
import { FilterUsuarioModel } from 'src/app/models/seguridad/FilterUsuarioModel';
import { IFilterSedeModel } from 'src/app/models/interfaces/sedes/IFilterSedeModel';
import { FilterSedeModel } from 'src/app/models/sede/FilterSedeModel';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { ParametroService } from 'src/app/services/parametros/parametro.service';
import { ParametroModel } from 'src/app/models/parametros/ParametroModel';
import { ActionResultModel } from 'src/app/models/common/ActionResultModel';
import { CompaniaModel } from 'src/app/models/compania/CompaniaModel';
import { CompaniaService } from 'src/app/services/compania/compania.service';
import { IFilterCompaniaModel } from 'src/app/models/interfaces/compania/IFilterCompaniaModel';
import { FilterCompaniaModel } from 'src/app/models/compania/FilterCompaniaModel';

@Component({
  selector: 'app-registrar-usuario-dialog',
  templateUrl: './registrar-usuario-dialog.component.html',
  styleUrls: ['./registrar-usuario-dialog.component.css'],
})
export class RegistrarUsuarioDialogComponent implements OnInit {
  listaSedes: SedeModel[] = new Array<SedeModel>();
  listaCompanias: CompaniaModel[] = new Array<CompaniaModel>();
  srcRoles!: IRoleModel[];
  listaRoles!: IRoleModel[];

  myControl = new FormControl();
  contratistaControl = new FormControl();

  filteredOptions!: Observable<ISeguridadUsuarioResultadoBusquedaModel[]>;
  contratistasOpcionesFiltradas!: Observable<ContratistaModel[]>;

  listaUsuarios: ISeguridadUsuarioResultadoBusquedaModel[] = new Array<ISeguridadUsuarioResultadoBusquedaModel>();
  listaContratistas: ContratistaModel[] = new Array<ContratistaModel>();

  paramsEstados: ParametroModel[] = new Array<ParametroModel>();
  existeContratista: boolean = false;
  existeEmpleado: boolean = false;

  constructor(
    private usuarioService: SeguridadUsuarioService,
    private companiaService: CompaniaService,
    private sedeService: SedeService,
    private rolesService: RolService,
    private contratistaService: ContratistaService,
    private seguridadUsuarioService: UsuarioService,
    private alertDialogService: AlertDialogService,
    public dialogRef: MatDialogRef<RegistrarUsuarioDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public model: IUsuarioRegistrarModel,
    private parametroService: ParametroService
  ) {
    // this.model = new UsuarioRegistrarModel();
    if (this.model.idUsuario !== 0) {
      this.usuarioService.getById(this.model.idUsuario)
        .subscribe(p => {
          this.model = p;
        });
      // console.log(model);
    }
    else {
      this.model = new UsuarioRegistrarModel();
      this.model.idTipo = TipoUsuario.Empleado;
    }
  }

  ngOnInit(): void {
    this.rolesService
      .getList()
      .subscribe((data: SearchResultModel<IRoleModel[]>) => {
        this.srcRoles = data.items;
        if (this.model.idTipo == TipoUsuario.Contratista) {
          this.listaRoles = data.items.filter(p => p.idRol == Roles.CONTRATISTA);
        }
        else {
          this.listaRoles = data.items.filter(p => p.idRol != Roles.CONTRATISTA);
        }
      });

    let filterSede: IFilterSedeModel = new FilterSedeModel();
    this.sedeService
      .getAllList(filterSede)
      .subscribe((data: SedeModel[]) => {
        this.listaSedes = data;
      });

    let filterCompania: IFilterCompaniaModel = new FilterCompaniaModel();
    this.companiaService
      .getAllList(filterCompania)
      .subscribe((data: CompaniaModel[]) => {
        this.listaCompanias = data;
      });


    if (this.model.idUsuario == 0) {
      this.filteredOptions = this.myControl.valueChanges.pipe(
        startWith(''),
        switchMap(value => this._filterUsuarios(value))
      );
    }

    const contratistaFilter = new FilterContratistaModel();
    // contratistaFilter.pageSize = 10000;

    this.contratistaService
      .getList(contratistaFilter)
      .subscribe((data: ContratistaModel[]) => {
        this.listaContratistas = data;
        // console.log(this.listaContratistas);
        // console.log(this.model.idContratista);
        this.contratistaControl.setValue(this.listaContratistas.find(p => p.idContratista == this.model.idContratista));

        this.contratistasOpcionesFiltradas = this.contratistaControl.valueChanges.pipe(
          startWith<string | IContratistaModel>(""),
          map(value => (typeof value === "string" ? value : value.nombre)),
          map(name => (name ? this._filtrarContratistas(name) : this.listaContratistas.slice()))
        );
      });

    this.parametroService
      .getDetalles(ParametrosMaestro.EstadosUsuarios)
      .subscribe((data) => {
        this.paramsEstados = data.items;
      });
  }

  private _filterUsuarios(value: string) {
    const usuariosFilter = new FilterUsuarioModel();
    usuariosFilter.idTipoUsuario = this.model.idTipo;

    if (typeof value == 'string') {
      usuariosFilter.correo = value.toString().toLowerCase();

      this.model.codigoUsuario = '';
      this.model.correo = '';
    }
    else {
      const usuario = (value as ISeguridadUsuarioResultadoBusquedaModel);
      usuariosFilter.correo = '';
      usuariosFilter.idUsuarios.push(usuario.id);

      this.model.codigoUsuario = usuario.id;
      this.model.nombres = usuario.firstName;
      this.model.apellidos = usuario.lastName;
      this.model.correo = usuario.email;
    }

    return this.seguridadUsuarioService.getList(usuariosFilter).pipe(
      filter(data => !!data),
      map((data) => {
        return data.items.filter(option => (`${option.firstName} ${option.lastName} ${option.email}`).toLocaleLowerCase().includes(value.toString().toLowerCase()))
      })
    );
  }

  private _filtrarContratistas(value: string): ContratistaModel[] {
    let filterValue = value.toString().toLowerCase();

    let result = this.listaContratistas.filter(
      (option) => option.nombre.toLowerCase().indexOf(filterValue) >= 0
    );
    return result;
  }

  displayContratista(memberid: IContratistaModel): string {
    if (memberid) {
      return `${memberid.nombre}`;
    }
    else {
      return '';
    }
  }

  displayFn(memberid: ISeguridadUsuarioResultadoBusquedaModel): string {
    if (memberid) {
      return `${memberid.firstName} ${memberid.lastName} - ${memberid.email}`; //`${memberid.email}`;
    }
    else {
      return '';
    }
  }

  Save(): void {
    if (this.model.idUsuario == 0) {
      this.usuarioService.submit(this.model).subscribe((result: ActionResultModel) => {
        if (result.type != eTypeResult.SUCCESS) {
          this.alertDialogService.open(result.message);
        }
        else {
          this.alertDialogService.open("El usuario ha sido registrado correctamente");
        }
      });
    } else {
      this.usuarioService.update(this.model).subscribe((result: ActionResultModel) => {
        if (result.type != eTypeResult.SUCCESS) {
          this.alertDialogService.open(result.message);
        }
        else {
          this.alertDialogService.open("El usuario ha sido actualizado correctamente");
        }
      });
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  changeTipoUsuario() {
    this.listaUsuarios = new Array<ISeguridadUsuarioResultadoBusquedaModel>();
    this.model.nombres = '';
    this.model.apellidos = '';
    this.model.correo = '';
    this.existeEmpleado = false;
    this.existeContratista = false;
    this.myControl.setValue('');

    if (this.model.idTipo == TipoUsuario.Contratista) {
      this.listaRoles = this.srcRoles.filter(p => p.idRol == Roles.CONTRATISTA);

      this.model.selectedRoles = [Roles.CONTRATISTA];
    }
    else {
      this.listaRoles = this.srcRoles.filter(p => p.idRol != Roles.CONTRATISTA);
      this.model.selectedRoles = [];
    }
  }

  getContratista(contratista: IContratistaModel) {
    this.model.idContratista = contratista.idContratista;
  }

  verificarCorreo(event: any) {
    // console.log(event.target.value);
    if (event.target.value !== '') {
      this.usuarioService.verificarSiExiste(event.target.value).subscribe((data) => {
        // console.log(data);
        this.existeContratista = data;
      });
    }
  }

  verificarUsuario(event: any) {
    // console.log(event);
    if (event.option.value.email !== '') {
      this.usuarioService.verificarSiExiste(event.option.value.email).subscribe((data) => {
        // console.log(data);
        this.existeEmpleado = data;
      });
    }
  }

  validForm() {
    let disabled = false;
    if (this.existeContratista || this.existeEmpleado || this.model.nombres == "" || this.model.apellidos == "" || this.model.correo == "" || this.model.selectedRoles == undefined || this.model.selectedRoles.length == 0 || this.model.selectedSedes.length == 0 || this.model.selectedCompanias.length == 0)
      disabled = true;

    return disabled;
  }
}
